import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Force direct instant scroll to top across window, html, and body
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Also scroll the main content area in case of layout-specific scrolling
    const main = document.querySelector('main');
    if (main) {
      main.scrollTop = 0;
    }

    // Scroll all custom scroll containers to top
    const scrollContainers = document.querySelectorAll('.overflow-y-auto, .overflow-auto');
    scrollContainers.forEach(container => {
      container.scrollTop = 0;
    });
  }, [pathname, search]);

  return null;
}
